<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_bg.png'"
  >
    <div class="short-teaser-inner-page" :data-project-number="project ? project.number : null">
      <h2 class="short-teaser-inner-page__heading">{{ $t('shortTeaserPrintPage2_heading') }}</h2>
      <div class="short-teaser-inner-page__main">
        <div class="short-teaser-inner-page__list">
          <ul>
            <li>{{ overviewBulletInstallationPower }}</li>
            <li>{{ $t('shortTeaserPrintPage2_overviewBullet2') }}</li>
            <li>{{ $t('shortTeaserPrintPage2_overviewBullet3') }}</li>
            <li>{{ $t('shortTeaserPrintPage2_overviewBullet4') }}</li>
            <li>{{ $t('shortTeaserPrintPage2_overviewBullet5') }}</li>
            <li>{{ overviewBulletTotalInvestment }}</li>
          </ul>
        </div>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import { formatNumber, NUMBER_FORMAT } from '@/helpers/numberFormat';

export default {
  name: 'ShortTeaserPrintPage2',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    overviewBulletInstallationPower() {
      return this.$t('shortTeaserPrintPage2_overviewBullet1', {
        powerKwpFormatted: formatNumber(
          this.project?.solarPlant?.solarPlantOverallPower,
          NUMBER_FORMAT.DECIMAL_TRIPLE
        ),
      });
    },

    overviewBulletTotalInvestment() {
      return this.$t('shortTeaserPrintPage2_overviewBullet6', {
        totalInvestmentFormatted: formatNumber(
          this.project?.effectiveSettlementValue,
          NUMBER_FORMAT.CURRENCY
        ),
      });
    },
  },
};
</script>
